<script lang="ts" setup>
/** A content card's partner logo: the logo inset on a small white disc, named for the partner. */
interface Props {
  src: string;
  partnerName?: string;
}

withDefaults(defineProps<Props>(), { partnerName: '' });
</script>

<template>
  <span class="flex size-6 items-center justify-center rounded-full bg-card p-1">
    <NuxtImg
      :src="src"
      :alt="partnerName"
      class="size-full object-contain"
    />
  </span>
</template>
